/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_Asana_NoteInputs */

const en_mk_calc_row_asana_note = /** @type {(inputs: Mk_Calc_Row_Asana_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$24.99 per seat. AI Teammates pricing is not published — contact sales.`)
};

const id_mk_calc_row_asana_note = /** @type {(inputs: Mk_Calc_Row_Asana_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$24,99 per kursi. Harga AI Teammates tidak dipublikasikan — hubungi sales.`)
};

/**
* | output |
* | --- |
* | "US$24.99 per seat. AI Teammates pricing is not published — contact sales." |
*
* @param {Mk_Calc_Row_Asana_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_asana_note = /** @type {((inputs?: Mk_Calc_Row_Asana_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_Asana_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_asana_note(inputs)
	return en_mk_calc_row_asana_note(inputs)
});